function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { Component } from 'react';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import memoize from 'memoize-one';
import { DragDropContext, Droppable } from '@hello-pangea/dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, DragUtils, LoadingSpinner } from '@deephaven/components';
import { dhNewCircleLargeFilled, vsWarning, vsPass } from '@deephaven/icons';
import { DbNameValidator } from '@deephaven/utils';
import CustomColumnInput from "./CustomColumnInput.js";
import "./CustomColumnBuilder.css";
import IrisGridModel from "../IrisGridModel.js";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
class CustomColumnBuilder extends Component {
  static makeCustomColumnInputEventKey() {
    return nanoid();
  }
  static createCustomColumnInput() {
    return {
      eventKey: nanoid(),
      name: '',
      formula: ''
    };
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "container", void 0);
    _defineProperty(this, "successButtonTimer", void 0);
    _defineProperty(this, "getInput", memoize((inputs, key) => inputs.find(input => input.eventKey === key)));
    _defineProperty(this, "getInputIndex", memoize((inputs, key) => inputs.findIndex(input => input.eventKey === key)));
    this.handleAddColumnClick = this.handleAddColumnClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDeleteColumn = this.handleDeleteColumn.bind(this);
    this.handleCustomColumnUpdated = this.handleCustomColumnUpdated.bind(this);
    this.handleRequestFailed = this.handleRequestFailed.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.resetRequestFailed = this.resetRequestFailed.bind(this);
    this.handleEditorTabNavigation = this.handleEditorTabNavigation.bind(this);
    this.state = {
      inputs: [],
      isCustomColumnApplying: false,
      errorMessage: null,
      hasRequestFailed: false,
      isSuccessShowing: false
    };
    this.container = null;
    this.successButtonTimer = null;
  }
  componentDidMount() {
    var customColumns = this.props.customColumns;
    this.parseCustomColumns(customColumns);
    this.startListening();
  }
  componentWillUnmount() {
    this.stopListening();
    if (this.successButtonTimer) {
      clearTimeout(this.successButtonTimer);
    }
  }
  resetErrorMessage() {
    this.setState({
      errorMessage: null
    });
  }
  startListening() {
    var model = this.props.model;
    model.addEventListener(IrisGridModel.EVENT.COLUMNS_CHANGED, this.handleCustomColumnUpdated);
    model.addEventListener(IrisGridModel.EVENT.UPDATED, this.handleCustomColumnUpdated);
    model.addEventListener(IrisGridModel.EVENT.REQUEST_FAILED, this.handleRequestFailed);
  }
  stopListening() {
    var model = this.props.model;
    model.removeEventListener(IrisGridModel.EVENT.COLUMNS_CHANGED, this.handleCustomColumnUpdated);
    model.removeEventListener(IrisGridModel.EVENT.UPDATED, this.handleCustomColumnUpdated);
    model.removeEventListener(IrisGridModel.EVENT.REQUEST_FAILED, this.handleRequestFailed);
  }
  parseCustomColumns(customColumns) {
    if (customColumns.length > 0) {
      var customColumnInputs = customColumns.map(customColumn => {
        var input = customColumn.split(/=(.+)/, 2);
        return {
          eventKey: CustomColumnBuilder.makeCustomColumnInputEventKey(),
          name: input[0],
          formula: input[1]
        };
      });
      this.setState({
        inputs: customColumnInputs
      });
    } else {
      this.setState({
        inputs: [CustomColumnBuilder.createCustomColumnInput()]
      });
    }
  }
  handleAddColumnClick() {
    var inputs = this.state.inputs;
    var newInputs = [...inputs];
    newInputs.push(CustomColumnBuilder.createCustomColumnInput());
    this.setState({
      inputs: newInputs
    });
  }
  handleDeleteColumn(eventKey) {
    var inputs = this.state.inputs;
    var customColumnIndex = this.getInputIndex(inputs, eventKey);
    var newInputs = [...inputs];
    newInputs.splice(customColumnIndex, 1);
    if (newInputs.length === 0) {
      newInputs.push(CustomColumnBuilder.createCustomColumnInput());
    }
    this.setState({
      inputs: newInputs
    });
  }
  handleInputChange(eventKey, type, value) {
    var inputs = this.state.inputs;
    var customColumnIndex = this.getInputIndex(inputs, eventKey);
    var customColumnInput = this.getInput(inputs, eventKey);
    var newCustomInput = _objectSpread({}, customColumnInput);
    newCustomInput[type] = value;
    var newInputs = [...inputs];
    newInputs.splice(customColumnIndex, 1, newCustomInput);
    this.setState({
      inputs: newInputs
    });
  }
  handleCustomColumnUpdated() {
    var isCustomColumnApplying = this.state.isCustomColumnApplying;
    if (!isCustomColumnApplying) {
      return;
    }
    this.setState({
      isCustomColumnApplying: false,
      isSuccessShowing: true
    }, () => {
      this.successButtonTimer = setTimeout(() => this.setState({
        isSuccessShowing: false
      }), CustomColumnBuilder.SUCCESS_SHOW_DURATION);
    });
  }
  handleRequestFailed(event) {
    var customEvent = event;
    var isCustomColumnApplying = this.state.isCustomColumnApplying;
    if (!isCustomColumnApplying) {
      return;
    }
    this.setState({
      isCustomColumnApplying: false,
      errorMessage: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
            icon: vsWarning
          }), " Failed to apply custom columns."]
        }), /*#__PURE__*/_jsxs("div", {
          className: "error-box",
          children: [customEvent.detail.errorMessage, /*#__PURE__*/_jsx("br", {}), "Table configuration:", ' ', JSON.stringify(customEvent.detail.configuration)]
        })]
      }),
      hasRequestFailed: true
    });
  }
  handleDragEnd(result) {
    DragUtils.stopDragging();

    // if dropped outside the list
    if (!result.destination) {
      return;
    }
    var inputs = this.state.inputs;
    var sourceIndex = result.source.index;
    var destinationIndex = result.destination.index;
    var newInputs = [...inputs];
    var sourceInput = inputs[sourceIndex];
    newInputs.splice(sourceIndex, 1);
    newInputs.splice(destinationIndex, 0, sourceInput);
    this.setState({
      inputs: newInputs
    });
  }
  handleEditorTabNavigation(focusEditorIndex, shiftKey) {
    var inputs = this.state.inputs;
    // focus on drag handle
    if (shiftKey) {
      var _this$container;
      ((_this$container = this.container) === null || _this$container === void 0 ? void 0 : _this$container.querySelectorAll('.btn-drag-handle')[focusEditorIndex]).focus();
      return;
    }
    if (focusEditorIndex === inputs.length - 1) {
      var _this$container2;
      (_this$container2 = this.container) === null || _this$container2 === void 0 || (_this$container2 = _this$container2.querySelector('.btn-add-column')) === null || _this$container2 === void 0 || _this$container2.focus();
    } else {
      var _this$container3;
      // focus on next column name input
      var nextFocusIndex = focusEditorIndex + 1;
      ((_this$container3 = this.container) === null || _this$container3 === void 0 ? void 0 : _this$container3.querySelectorAll(".custom-column-input")[nextFocusIndex]).focus();
    }
  }
  handleSaveClick() {
    var _this$props = this.props,
      onSave = _this$props.onSave,
      originalCustomColumns = _this$props.customColumns;
    var _this$state = this.state,
      inputs = _this$state.inputs,
      isCustomColumnApplying = _this$state.isCustomColumnApplying;
    if (isCustomColumnApplying) {
      return;
    }
    var customColumns = [];
    inputs.forEach(input => {
      var name = input.name,
        formula = input.formula;
      if (name && formula) {
        customColumns.push("".concat(name, "=").concat(formula));
      }
    });
    this.resetErrorMessage();
    this.setState({
      // If both are 0, then moving from no custom to no custom. The parent won't re-render to cancel the loading state
      isCustomColumnApplying: customColumns.length > 0 || originalCustomColumns.length > 0
    });
    onSave(customColumns);
  }
  resetRequestFailed() {
    this.setState(_ref => {
      var hasRequestFailed = _ref.hasRequestFailed;
      if (hasRequestFailed) {
        return {
          hasRequestFailed: false
        };
      }
      return null;
    });
  }
  renderInputs() {
    var _this$state2 = this.state,
      inputs = _this$state2.inputs,
      hasRequestFailed = _this$state2.hasRequestFailed;
    var nameCount = new Map();
    inputs.forEach(_ref2 => {
      var _nameCount$get;
      var name = _ref2.name;
      return nameCount.set(name, ((_nameCount$get = nameCount.get(name)) !== null && _nameCount$get !== void 0 ? _nameCount$get : 0) + 1);
    });
    return inputs.map((input, index) => {
      var _nameCount$get2;
      var eventKey = input.eventKey,
        name = input.name,
        formula = input.formula;
      var isDuplicate = ((_nameCount$get2 = nameCount.get(name)) !== null && _nameCount$get2 !== void 0 ? _nameCount$get2 : 0) > 1;
      return /*#__PURE__*/_jsx(CustomColumnInput, {
        inputIndex: index,
        eventKey: eventKey,
        name: name,
        formula: formula,
        onChange: this.handleInputChange,
        onDeleteColumn: this.handleDeleteColumn,
        onTabInEditor: this.handleEditorTabNavigation,
        invalid: hasRequestFailed,
        isDuplicate: isDuplicate
      }, eventKey);
    });
  }
  renderSaveButton() {
    var _this$state3 = this.state,
      inputs = _this$state3.inputs,
      isCustomColumnApplying = _this$state3.isCustomColumnApplying,
      isSuccessShowing = _this$state3.isSuccessShowing;
    var saveText = inputs.length > 1 ? 'Save Columns' : 'Save Column';
    var areNamesValid = inputs.every(_ref3 => {
      var name = _ref3.name;
      return name === '' || DbNameValidator.isValidColumnName(name);
    });
    var filteredNames = inputs.filter(_ref4 => {
      var name = _ref4.name;
      return name !== '';
    }).map(_ref5 => {
      var name = _ref5.name;
      return name;
    });
    var areNamesUnique = new Set(filteredNames).size === filteredNames.length;
    return /*#__PURE__*/_jsxs(Button, {
      kind: isSuccessShowing ? 'success' : 'primary',
      className: classNames('btn-apply', {
        'btn-spinner': isCustomColumnApplying
      }),
      disabled: isSuccessShowing || isCustomColumnApplying || !areNamesValid || !areNamesUnique,
      onClick: this.handleSaveClick,
      icon: isSuccessShowing ? vsPass : undefined,
      children: [isCustomColumnApplying && /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(LoadingSpinner, {
          className: "mr-2 loading-spinner-vertical-align"
        }), /*#__PURE__*/_jsx("span", {
          className: "btn-normal-content",
          children: "Applying"
        })]
      }), !isSuccessShowing && !isCustomColumnApplying && saveText, isSuccessShowing && 'Success']
    });
  }
  render() {
    var onCancel = this.props.onCancel;
    var errorMessage = this.state.errorMessage;
    return /*#__PURE__*/_jsxs("div", {
      role: "presentation",
      className: "custom-column-builder-container",
      ref: container => {
        this.container = container;
      },
      onClick: this.resetRequestFailed,
      onFocus: this.resetRequestFailed,
      children: [/*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsx(DragDropContext, {
        onDragStart: DragUtils.startDragging,
        onDragEnd: this.handleDragEnd,
        children: /*#__PURE__*/_jsx(Droppable, {
          droppableId: "droppable-custom-columns",
          children: (provided, snapshot) => /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
            ref: provided.innerRef
            // eslint-disable-next-line react/jsx-props-no-spreading
          }, provided.droppableProps), {}, {
            className: classNames('droppable-container', {
              dragging: snapshot.draggingFromThisWith
            }),
            children: [this.renderInputs(), provided.placeholder]
          }))
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "pt-1 px-3",
        children: /*#__PURE__*/_jsx(Button, {
          kind: "ghost",
          className: "btn-add-column",
          onClick: this.handleAddColumnClick,
          icon: dhNewCircleLargeFilled,
          children: "Add Another Column"
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "custom-column-builder-footer",
        children: [errorMessage && /*#__PURE__*/_jsx("div", {
          className: "error-message",
          children: errorMessage
        }), /*#__PURE__*/_jsxs("div", {
          className: "d-flex justify-content-end",
          children: [/*#__PURE__*/_jsx(Button, {
            kind: "secondary",
            className: "mr-2",
            onClick: onCancel,
            children: "Cancel"
          }), this.renderSaveButton()]
        })]
      })]
    });
  }
}
_defineProperty(CustomColumnBuilder, "SUCCESS_SHOW_DURATION", 750);
export default CustomColumnBuilder;
//# sourceMappingURL=CustomColumnBuilder.js.map